import { render, staticRenderFns } from "./QuotationDiscountCard.vue?vue&type=template&id=6c56c0dd"
import script from "./QuotationDiscountCard.vue?vue&type=script&lang=ts"
export * from "./QuotationDiscountCard.vue?vue&type=script&lang=ts"
import style0 from "./QuotationDiscountCard.vue?vue&type=style&index=0&id=6c56c0dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports